import React, { useEffect, useState, createElement } from 'react';
import { Link } from 'react-router-dom';
import { Search, TrendingUp, TrendingDown, Sparkles, LineChart, ArrowUpRight, ChevronRight, Shield, Leaf, FileText, Activity, CheckCircle2, ChevronLeft, AlertCircle, Network } from 'lucide-react';
import { AppCard } from '../components/base/AppCard';
import { AppBadge } from '../components/base/AppBadge';
import { MiniSparkline } from '../components/charts/MiniSparkline';
const SLIDES = [{
  id: 1,
  badge: 'Azione richiesta',
  title: '1 Anomalia Rilevata',
  desc: 'Il servizio Customer Assistant sta generando costi superiori alla media.',
  btnText: 'Verifica anomalia',
  icon: Activity,
  colorClass: 'bg-red-500/80',
  bgGlow: 'bg-red-500/10'
}, {
  id: 2,
  badge: 'Suggerimento',
  title: 'Nuovo Modello',
  desc: 'Passa a GPT-4o-mini per risparmiare il 40% sui costi di inferenza.',
  btnText: 'Scopri di più',
  icon: Sparkles,
  colorClass: 'bg-[#00B4D8]/80',
  bgGlow: 'bg-[#00B4D8]/10'
}, {
  id: 3,
  badge: 'Compliance',
  title: 'Update AI Act',
  desc: 'Nuove linee guida disponibili per la classificazione del rischio dei modelli.',
  btnText: 'Leggi policy',
  icon: Shield,
  colorClass: 'bg-amber-500/80',
  bgGlow: 'bg-amber-500/10'
}];
export function CostManagementPage() {
  const [activeTab, setActiveTab] = useState('In evidenza');
  const [expandedCard, setExpandedCard] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % SLIDES.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  return <div className="min-h-screen bg-[#F4F6F8] p-4 md:p-8" data-id="element-2474">
      {/* Header Section */}
      <div className="flex flex-col lg:flex-row justify-between items-stretch gap-8 mb-10" data-id="element-2475">
        <div className="flex-1 flex flex-col justify-center" data-id="element-2476">
          <h1 className="md:text-[32px] text-[#1A202C] tracking-tight mb-3 text-[28px] font-[600]" data-id="element-2477">
            Ciao, Marco!
            <br data-id="element-2478" />
            Ecco il riepilogo della tua infrastruttura AI.
          </h1>
          <p className="text-[14px] text-gray-600 max-w-2xl mb-5 leading-relaxed" data-id="element-2479">
            I costi mostrano un picco insolito, mentre compliance e
            sostenibilità sono nella norma.
          </p>
          <div className="flex flex-wrap items-center gap-3 mb-6" data-id="element-2480">
            <div className="flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-200 rounded-lg shadow-sm" data-id="element-2481">
              <Activity className="w-4 h-4 text-[#00B4D8]" data-id="element-2482" />
              <span className="text-[13px] font-medium text-gray-700" data-id="element-2483">
                12 Servizi Monitorati
              </span>
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 bg-red-50 border border-red-100 rounded-lg shadow-sm" data-id="element-2484">
              <AlertCircle className="w-4 h-4 text-red-500" data-id="element-2485" />
              <span className="text-[13px] font-medium text-red-700" data-id="element-2486">
                1 Richiede Attenzione
              </span>
            </div>
            <Link to="/canvas" className="flex items-center gap-2 px-3 py-1.5 bg-[#2A3B5C] text-white rounded-lg shadow-sm hover:bg-[#1E2A40] transition-colors" data-id="element-2487">
              <Network className="w-4 h-4" data-id="element-2488" />
              <span className="text-[13px] font-medium" data-id="element-2489">Vai alla Mappa AI</span>
              <ArrowUpRight className="w-3 h-3 opacity-70" data-id="element-2490" />
            </Link>
          </div>
        </div>

        {/* Status Slider Card */}
        <div className="relative w-full lg:w-[420px] min-h-[200px] rounded-2xl bg-gradient-to-br from-[#2A3B5C] to-[#1E2A40] border border-[#2A3B5C]/20 overflow-hidden flex flex-col p-6 shrink-0 shadow-lg group" data-id="element-2491">
          {/* Abstract decorative shapes - Dynamic based on slide */}
          <div className={`absolute top-[-20%] right-[-10%] w-48 h-48 rounded-full blur-3xl mix-blend-screen pointer-events-none transition-colors duration-1000 ${SLIDES[currentSlide].bgGlow}`} data-id="element-2492"></div>
          <div className={`absolute bottom-[-10%] left-[20%] w-40 h-40 rounded-full blur-3xl mix-blend-screen pointer-events-none transition-colors duration-1000 ${SLIDES[currentSlide].bgGlow}`} data-id="element-2493"></div>

          <div className="relative z-10 flex-1 flex flex-col justify-between" data-id="element-2494">
            <div className="flex items-center justify-between mb-2" data-id="element-2495">
              <span className="text-white/60 text-[12px] uppercase tracking-wider font-medium" data-id="element-2496">
                Notifiche di Sistema
              </span>
              <span className="flex items-center gap-1.5 text-white text-[12px] font-medium bg-white/10 px-2.5 py-1 rounded-full border border-white/20 backdrop-blur-md transition-all duration-500" data-id="element-2497">
                {createElement(SLIDES[currentSlide].icon, {
                className: 'w-3.5 h-3.5'
              })}
                {SLIDES[currentSlide].badge}
              </span>
            </div>

            {/* Carousel Content */}
            <div className="mt-4 relative h-[70px] overflow-hidden" data-id="element-2498">
              {SLIDES.map((slide, index) => <div key={slide.id} className={`absolute inset-0 transition-all duration-500 ease-in-out ${index === currentSlide ? 'opacity-100 translate-x-0' : index < currentSlide ? 'opacity-0 -translate-x-full' : 'opacity-0 translate-x-full'}`} data-id="element-2499">
                  <h2 className="text-white font-heading font-bold tracking-tight text-[28px]" data-id="element-2500">
                    {slide.title}
                  </h2>
                  <p className="text-white/70 text-[13px] mt-1 max-w-[280px]" data-id="element-2501">
                    {slide.desc}
                  </p>
                </div>)}
            </div>

            {/* Bottom Section: Button & Pagination */}
            <div className="mt-6 flex items-center justify-between" data-id="element-2502">
              <button className="flex items-center gap-2 px-5 py-2.5 rounded-xl bg-white/10 backdrop-blur-md border border-white/20 text-white text-[13px] font-medium hover:bg-white/20 transition-colors shadow-lg" data-id="element-2503">
                <span className={`flex items-center justify-center min-w-[20px] h-[20px] text-white rounded-full text-[11px] font-bold transition-colors duration-500 ${SLIDES[currentSlide].colorClass}`} data-id="element-2504">
                  {currentSlide + 1}
                </span>
                {SLIDES[currentSlide].btnText}
                <ArrowUpRight className="w-4 h-4 text-white/70 ml-1" data-id="element-2505" />
              </button>

              {/* Pagination Dots */}
              <div className="flex items-center gap-1.5" data-id="element-2506">
                {SLIDES.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`h-1.5 rounded-full transition-all duration-300 ${index === currentSlide ? 'w-4 bg-white' : 'w-1.5 bg-white/30 hover:bg-white/50'}`} data-id="element-2507" />)}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Section */}
      <div className="border-b-2 border-gray-300 mb-6" data-id="element-2508">
        <div className="-mb-[2px] flex items-center gap-8 overflow-x-auto custom-scrollbar" data-id="element-2509">
          {['In evidenza', 'Per te', 'Tutti i servizi'].map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`pb-3 text-[16px] transition-colors whitespace-nowrap border-b-2 ${activeTab === tab ? 'border-[#00B4D8] text-[#2A3B5C]' : 'border-transparent text-gray-500 hover:text-gray-800'}`} data-id="element-2510">
              {tab}
            </button>)}
        </div>
      </div>

      {/* Metric Cards Section - Netflix-style Accordion */}
      <div className="flex flex-col lg:flex-row gap-6 lg:h-[420px]" data-id="element-2511">
        {/* Card 1: Gestione Costi */}
        <div onMouseEnter={() => setExpandedCard(0)} className={`bg-white border border-gray-200 rounded-2xl p-6 flex flex-col relative overflow-hidden cursor-pointer transition-all duration-500 ease-in-out shadow-sm hover:shadow-md ${expandedCard === 0 ? 'flex-[2]' : 'flex-1'}`} data-id="element-2512">
          <div className="flex items-start justify-between mb-4 relative z-10" data-id="element-2513">
            <h3 className="text-[16px] font-semibold text-[#1A202C] whitespace-nowrap flex items-center gap-2" data-id="element-2514">
              <LineChart className="w-4 h-4 text-[#00B4D8]" data-id="element-2515" />
              Gestione Costi
            </h3>
            <AppBadge variant="default" className="bg-red-50 text-red-600 border border-red-100 shrink-0" data-id="element-2516">
              Da verificare
            </AppBadge>
          </div>

          <div className="relative z-10" data-id="element-2517">
            <p className="font-heading font-bold text-[#1A202C] text-[28px]" data-id="element-2518">
              € 2.435
            </p>
          </div>

          {/* Collapsed Preview */}
          <div className={`transition-all duration-500 ease-in-out overflow-hidden ${expandedCard === 0 ? 'max-h-0 opacity-0' : 'max-h-[100px] opacity-100'}`} data-id="element-2519">
            <div className="pt-3" data-id="element-2520">
              <div className="flex items-center gap-1.5 text-[12px] text-red-600 font-medium mb-2" data-id="element-2521">
                <TrendingUp className="w-3.5 h-3.5" data-id="element-2522" /> +17% vs media
              </div>
              <div className="mb-2" data-id="element-2523">
                <MiniSparkline data={[10, 12, 15, 14, 20, 25, 30]} color="#ef4444" className="h-[24px]" data-id="element-2524" />
              </div>
              <p className="text-[12px] text-gray-500 leading-snug line-clamp-1" data-id="element-2525">
                Picco su Customer Assistant.
              </p>
            </div>
          </div>

          {/* Expanded Content */}
          <div className={`transition-all duration-500 ease-in-out flex flex-col ${expandedCard === 0 ? 'flex-1 max-h-[400px] mt-4' : 'max-h-0 mt-0'} overflow-hidden`} data-id="element-2526">
            <div className={`transition-opacity duration-500 ease-in-out flex flex-col flex-1 ${expandedCard === 0 ? 'opacity-100 delay-150' : 'opacity-0'}`} data-id="element-2527">
              {/* Custom Inline SVG Chart */}
              <div className="w-full h-[100px] mt-auto relative z-10 text-[#00B4D8] mb-4 shrink-0" data-id="element-2528">
                <svg viewBox="0 0 400 120" className="w-full h-full overflow-visible" preserveAspectRatio="none" data-id="element-2529">
                  {/* Background faded bars */}
                  <g opacity="0.1" fill="currentColor" data-id="element-2530">
                    {Array.from({
                    length: 40
                  }).map((_, i) => {
                    const height = 40 + Math.sin(i * 0.3) * 10 + (i > 30 ? (i - 30) * 4 : 0);
                    return <rect key={i} x={i * 10} y={120 - height} width="6" height={height} rx="2" data-id="element-2531" />;
                  })}
                  </g>

                  <line x1="300" y1="10" x2="300" y2="120" stroke="#CBD5E0" strokeWidth="1" strokeDasharray="4 4" data-id="element-2532" />

                  <path d="M 0 90 Q 50 100, 100 80 T 200 95 T 300 85 L 390 30" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-2533" />

                  <text x="0" y="75" fill="#718096" fontSize="12" fontWeight="500" data-id="element-2534">
                    1.3K
                  </text>
                  <text x="365" y="20" fill="#718096" fontSize="12" fontWeight="500" data-id="element-2535">
                    1.6K
                  </text>
                </svg>
              </div>

              <p className="text-[13px] text-gray-600 leading-relaxed mb-4" data-id="element-2536">
                Picco di spesa rilevato nel servizio Customer Assistant (+17%
                rispetto alla media).
              </p>

              <div className="flex flex-col gap-2 mt-auto" data-id="element-2537">
                <button className="w-full flex items-center justify-center px-6 py-3 bg-[#2A3B5C] text-white rounded-md hover:bg-[#1E2A40] transition-colors" data-id="element-2538">
                  <span className="text-[15px] font-heading uppercase tracking-wide whitespace-nowrap" data-id="element-2539">
                    Analisi Dettagliata
                  </span>
                </button>
                <button className="w-full flex items-center justify-center px-6 py-3 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors" data-id="element-2540">
                  <span className="text-[15px] font-heading uppercase tracking-wide whitespace-nowrap" data-id="element-2541">
                    Ottimizza Costi
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Card 2: Compliance */}
        <div onMouseEnter={() => setExpandedCard(1)} className={`bg-white border border-gray-200 rounded-2xl p-6 flex flex-col cursor-pointer overflow-hidden transition-all duration-500 ease-in-out shadow-sm hover:shadow-md ${expandedCard === 1 ? 'flex-[2]' : 'flex-1'}`} data-id="element-2542">
          <div className="flex items-start justify-between mb-4" data-id="element-2543">
            <h3 className="text-[16px] font-semibold text-[#1A202C] whitespace-nowrap flex items-center gap-2" data-id="element-2544">
              <Shield className="w-4 h-4 text-[#00B4D8]" data-id="element-2545" />
              Compliance
            </h3>
            <AppBadge variant="default" className="bg-emerald-50 text-emerald-600 border border-emerald-100 shrink-0" data-id="element-2546">
              Conforme
            </AppBadge>
          </div>

          <div data-id="element-2547">
            <p className="font-heading font-bold text-[#1A202C] text-[28px]" data-id="element-2548">
              98%
            </p>
          </div>

          {/* Collapsed Preview */}
          <div className={`transition-all duration-500 ease-in-out overflow-hidden ${expandedCard === 1 ? 'max-h-0 opacity-0' : 'max-h-[100px] opacity-100'}`} data-id="element-2549">
            <div className="pt-3 flex flex-col gap-2" data-id="element-2550">
              <div className="w-full bg-gray-100 rounded-full h-1.5 mb-1" data-id="element-2551">
                <div className="bg-emerald-500 h-1.5 rounded-full" style={{
                width: '98%'
              }} data-id="element-2552"></div>
              </div>
              <span className="text-[12px] text-gray-600 flex items-center gap-1.5" data-id="element-2553">
                <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500" data-id="element-2554" /> 0
                violazioni
              </span>
              <span className="text-[12px] text-gray-600 flex items-center gap-1.5" data-id="element-2555">
                <Shield className="w-3.5 h-3.5 text-emerald-500" data-id="element-2556" /> Rischio
                Basso
              </span>
            </div>
          </div>

          {/* Expanded Content */}
          <div className={`transition-all duration-500 ease-in-out flex flex-col ${expandedCard === 1 ? 'flex-1 max-h-[400px] mt-4' : 'max-h-0 mt-0'} overflow-hidden`} data-id="element-2557">
            <div className={`transition-opacity duration-500 ease-in-out flex flex-col flex-1 ${expandedCard === 1 ? 'opacity-100 delay-150' : 'opacity-0'}`} data-id="element-2558">
              <div className="flex flex-wrap gap-2 mb-4" data-id="element-2559">
                <span className="text-[11px] text-gray-600 flex items-center gap-1 bg-gray-100 px-2.5 py-1 rounded-full w-fit font-medium" data-id="element-2560">
                  <CheckCircle2 className="w-3 h-3 text-emerald-500" data-id="element-2561" /> 0
                  violazioni critiche
                </span>
                <span className="text-[11px] text-gray-600 flex items-center gap-1 bg-gray-100 px-2.5 py-1 rounded-full w-fit font-medium" data-id="element-2562">
                  <CheckCircle2 className="w-3 h-3 text-emerald-500" data-id="element-2563" /> 100% log
                  conservati
                </span>
                <span className="text-[11px] text-gray-600 flex items-center gap-1 bg-gray-100 px-2.5 py-1 rounded-full w-fit font-medium" data-id="element-2564">
                  <Shield className="w-3 h-3 text-emerald-500" data-id="element-2565" /> Rischio AI
                  Act: Basso
                </span>
              </div>

              <p className="text-[13px] text-gray-600 leading-relaxed mb-4" data-id="element-2566">
                Tutti i servizi operativi rispettano i requisiti normativi.
                Ultimo audit superato con successo.
              </p>

              <div className="flex flex-col gap-2 mt-auto" data-id="element-2567">
                <button className="w-full flex items-center justify-center px-6 py-3 bg-[#2A3B5C] text-white rounded-md hover:bg-[#1E2A40] transition-colors" data-id="element-2568">
                  <span className="text-[15px] font-heading uppercase tracking-wide whitespace-nowrap" data-id="element-2569">
                    Vedi Audit Trail
                  </span>
                </button>
                <button className="w-full flex items-center justify-center px-6 py-3 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors" data-id="element-2570">
                  <span className="text-[15px] font-heading uppercase tracking-wide whitespace-nowrap" data-id="element-2571">
                    Report AI Act
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Card 3: GreenOps */}
        <div onMouseEnter={() => setExpandedCard(2)} className={`bg-white border border-gray-200 rounded-2xl p-6 flex flex-col cursor-pointer overflow-hidden transition-all duration-500 ease-in-out shadow-sm hover:shadow-md ${expandedCard === 2 ? 'flex-[2]' : 'flex-1'}`} data-id="element-2572">
          <div className="flex items-start justify-between mb-4" data-id="element-2573">
            <h3 className="text-[16px] font-semibold text-[#1A202C] whitespace-nowrap flex items-center gap-2" data-id="element-2574">
              <Leaf className="w-4 h-4 text-[#00B4D8]" data-id="element-2575" />
              GreenOps
            </h3>
            <AppBadge variant="default" className="bg-emerald-50 text-emerald-600 border border-emerald-100 shrink-0" data-id="element-2576">
              Ottimizzato
            </AppBadge>
          </div>

          <div data-id="element-2577">
            <p className="font-heading font-bold text-[#1A202C] text-[28px]" data-id="element-2578">
              124 kg CO₂
            </p>
          </div>

          {/* Collapsed Preview */}
          <div className={`transition-all duration-500 ease-in-out overflow-hidden ${expandedCard === 2 ? 'max-h-0 opacity-0' : 'max-h-[100px] opacity-100'}`} data-id="element-2579">
            <div className="pt-3" data-id="element-2580">
              <div className="flex items-center gap-1.5 text-[12px] text-emerald-600 font-medium mb-2" data-id="element-2581">
                <TrendingDown className="w-3.5 h-3.5" data-id="element-2582" /> -15% vs mese scorso
              </div>
              <div className="mb-2" data-id="element-2583">
                <MiniSparkline data={[30, 28, 25, 22, 18, 15, 12]} color="#10b981" className="h-[24px]" data-id="element-2584" />
              </div>
              <p className="text-[12px] text-gray-500 leading-snug line-clamp-1" data-id="element-2585">
                Routing dinamico SLM attivo.
              </p>
            </div>
          </div>

          {/* Expanded Content */}
          <div className={`transition-all duration-500 ease-in-out flex flex-col ${expandedCard === 2 ? 'flex-1 max-h-[400px] mt-4' : 'max-h-0 mt-0'} overflow-hidden`} data-id="element-2586">
            <div className={`transition-opacity duration-500 ease-in-out flex flex-col flex-1 ${expandedCard === 2 ? 'opacity-100 delay-150' : 'opacity-0'}`} data-id="element-2587">
              <div className="mb-4" data-id="element-2588">
                <span className="text-[12px] text-emerald-700 flex items-center gap-1 bg-emerald-50 border border-emerald-100 px-2.5 py-1 rounded-full w-fit font-medium" data-id="element-2589">
                  <TrendingDown className="w-3 h-3" data-id="element-2590" /> -15% vs mese scorso
                </span>
              </div>

              <p className="text-[13px] text-gray-600 leading-relaxed mb-4" data-id="element-2591">
                Risparmiati 45 kg di CO₂ questo mese grazie al routing dinamico
                verso modelli più efficienti (SLM).
              </p>

              <div className="flex flex-col gap-2 mt-auto" data-id="element-2592">
                <button className="w-full flex items-center justify-center px-6 py-3 bg-[#2A3B5C] text-white rounded-md hover:bg-[#1E2A40] transition-colors" data-id="element-2593">
                  <span className="text-[15px] font-heading uppercase tracking-wide whitespace-nowrap" data-id="element-2594">
                    Dettaglio Emissioni
                  </span>
                </button>
                <button className="w-full flex items-center justify-center px-6 py-3 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors" data-id="element-2595">
                  <span className="text-[15px] font-heading uppercase tracking-wide whitespace-nowrap" data-id="element-2596">
                    Suggerimenti Eco
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}